import { ICONS } from './func';

export interface NetworkInfo {
  name: string;
  icon: string;
}

// Network ID to Network Info mapping
const NETWORK_MAP: Record<number, NetworkInfo> = {
  10: { name: 'Ethereum', icon: ICONS.Ethereum },
  11: { name: 'Astar', icon: ICONS.Astar },
  12: { name: 'Binance', icon: ICONS.Binance },
  13: { name: 'Arbitrum', icon: ICONS.Arbitrum },
};

/**
 * Gets the network name from a network ID
 * @param networkId - The network ID to look up
 * @returns The network name as a string, or empty string if not found
 */
export const getNetwork = (networkId: number): string => {
  return NETWORK_MAP[networkId]?.name || '';
};

/**
 * Gets the network icon from a network ID
 * @param networkId - The network ID to look up
 * @returns The network icon path as a string, or empty string if not found
 */
export const getNetworkIcon = (networkId: number): string => {
  return NETWORK_MAP[networkId]?.icon || '';
};
